import { createContext, useContext, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { getContact, addContact, updateContact } from "../../api/contactus";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const getContactQuery = useQuery({
    queryKey: ["contact-us"],
    queryFn: getContact,
  });
  const addContactQuery = useMutation({ mutationFn: addContact });
  const updateContactQuery = useMutation({ mutationFn: updateContact });
  const toaster = useToaster();

  const initialValues = useMemo(() => {
    const contactData = getContactQuery?.data?.data?.[0] || {};

    return {
      meta: {
        meta_title: contactData?.meta_title || "",
        meta_slug_url: contactData?.meta_slug_url || "",
        meta_description: contactData?.meta_description || "",
        keywords: contactData?.keywords || "",
      },
      contact: {
        heading: contactData?.heading || "",
        description: contactData?.description || "",
      },
      information: {
        heading: contactData?.information?.heading || "",
        subheading: contactData?.information?.subheading || "",
        mobile_no: contactData?.information?.mobile_no || "",
        email: contactData?.information?.email || "",
        address: contactData?.information?.address || "",
      },
    };
  }, [getContactQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      meta_title: values?.meta?.meta_title || "",
      meta_slug_url: values?.meta?.meta_slug_url || "",
      meta_description: values?.meta?.meta_description || "",
      keywords: values?.meta?.keywords || "",

      heading: values?.contact?.heading || "",
      description: values?.contact?.description || "",

      information: {
        heading: values?.information?.heading || "",
        subheading: values?.information?.subheading || "",
        mobile_no: values?.information?.mobile_no || "",
        email: values?.information?.email || "",
        address: values?.information?.address || "",
      },
    };

    const contactData = getContactQuery?.data?.data?.[0] || {};

    if (contactData._id) {
      payload.id = contactData._id;
      updateContactQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success(
            Const.MESSAGES.SUCCESS,
            Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
          );
        },
      });
      return;
    }
    addContactQuery.mutate(payload, {
      onSuccess: () => {
        toaster.success(
          Const.MESSAGES.SUCCESS,
          Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY
        );
      },
    });
  };
  return (
    <PageContext.Provider
      value={{ initialValues, handleSubmit, getContactQuery }}>
      {children}
    </PageContext.Provider>
  );
};

export const useContactProvider = () => {
  return useContext(PageContext);
};
